export default "__VITE_ASSET__BDeFIQN8__"